import { Component, Injector, Optional } from '@angular/core';

import { SoortService } from 'src/app/core/service/soort.service';
import { Soort } from 'src/app/core/dto/soort';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';

@Component({
    selector: 'c-i-j-borculo-soort-collection',
    templateUrl: './soort-collection.component.html'/*,
    styleUrls: ['./soort-collection.component.css'] */
})
export class SoortCollectionComponent extends PagedCollectionComponent<Soort> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Soort>([
		{ colDef: 'omschrijving', prop: x => x.omschrijving, searchable: SearchableType.String }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: SoortService, @Optional() protected filter: Filter<Soort>, injector: Injector) {
        super('/soort/soort', injector, Soort);

        this.filter.onGetChipLabel(x => x.omschrijving, () => 'Omschrijving');
		
    }
}